import { Routes } from '@angular/router';
import { DefaultLayoutComponent, EmailLayoutComponent } from './layout';
import { AuthGuard } from '@infra-adapters/guards/auth.guard';
import { InvalidSessionGuard } from '@infra-adapters/guards/invalidSession.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'apps/email',
    component: EmailLayoutComponent,

    children: [
      {
        path: '',
        loadChildren: () => import('./views/apps/email/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./views/home/routes').then((m) => m.routes)
      },
      {
        path: 'maestros',
        loadChildren: () => import('./views/masters/routes').then((m) => m.routes)
      },
      {
        path: 'banners',
        loadChildren: () => import('./views/banners/routes').then((m) => m.routes)
      },
      {
        path: 'welcome',
        loadChildren: () => import('./views/welcomeConfig/routes').then((m) => m.routes)
      },
      {
        path: 'popup',
        loadChildren: () => import('./views/popup/routes').then((m) => m.routes)
      },
      {
        path: 'promociones',
        loadChildren: () => import('./views/promotions/routes').then((m) => m.routes)
      },
      {
        path: 'capacitaciones',
        loadChildren: () => import('./views/capacitations/routes').then((m) => m.routes)
      },
      {
        path: 'puntos-de-venta',
        loadChildren: () => import('./views/sale-points/routes').then((m) => m.routes)
      },
      {
        path: 'productos',
        loadChildren: () => import('./views/products/routes').then((m) => m.routes)
      },
      {
        path: 'notificaciones',
        loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'login',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'forgot-password',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Forgot Password Page'
    }
  },
  {
    path: 'reset-code',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Reset Code Page'
    }
  },
  {
    path: 'reset-password',
    canActivate: [InvalidSessionGuard],
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Reset Password Page'
    }
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  { path: '**', redirectTo: 'home' }
];
